<template>
  <div>
    <nav id="bodyTop" class="d_flex bodyTop">
      <div style="width: 1300px;margin: auto" class="d_flex">
        <span style="flex: auto;margin-top: -2px;padding: 0 20px 0 0">
          <span v-if="!isRegister" style="padding-left: 0"><abbr class="colorGray959595 dis_line v_m m_r_10">百钢欢迎您</abbr><abbr @click="toLogin" class="hover2 dis_line v_m c_p">登录</abbr> <abbr class=" dis_line v_m">/</abbr> <abbr @click="toRegister" class=" dis_line v_m hover2 c_p">注册</abbr></span>
        <div v-if="isRegister" style="display: inline-block;padding: 0 20px;margin-left: -20px" class="hover p_r">
          <div class="hover2"><abbr class="colorGray959595 dis_line v_m m_r_10">百钢欢迎您！</abbr><abbr>{{ MemberInfo.name }}</abbr><i style="font-size: 10px;margin-left: 5px" class="icon iconfont f_w iconicon-"></i></div>
          <div style="top: 30px;left: 0;width: 200px;padding: 10px;text-align: left;" class="p_a hoverShow">
            <div>
              <p style="line-height: 20px">当前身份：{{ returnType(MemberInfo.account && MemberInfo.account.type, MemberInfo.account && MemberInfo.account.companyAuth) }}</p>
              <p style="line-height: 20px">{{ MemberInfo.mobile }}</p>
            </div>
            <div style="border-top: 1px solid #eee;padding-top: 10px">
              <div style="width: 49%" class="dis_line">
                <div @click="toCenterUrl('companyBasicInfo')" class="title c_p">账号信息</div>
              </div>
              <div style="width: 49%"  class="dis_line">
                <div @click="toCenterUrl('newPwdmanage')" class="title c_p">账号安全</div>
              </div>
              <div style="width: 49%"  class="">
                <div @click="$commonJs.loginOut('login')" class="title c_p">退出登录</div>
              </div>
            </div>
          </div>
        </div>
<!--          <div v-if="!isRegister" style="padding: 0;"><abbr class="colorGray959595 dis_line v_m m_r_10">百钢欢迎您</abbr><abbr @click="toLogin" class="hover2 dis_line v_m c_p">登录</abbr>-->
<!--            <abbr class=" dis_line v_m">/</abbr> <abbr @click="toRegister" class=" dis_line v_m hover2 c_p">注册</abbr></div>-->
<!--          <div v-if="isRegister" style="display: inline-block;padding: 0 20px;margin-left: -20px" class="hover p_r">-->
<!--            <div class="hover2" style="padding: 0 30px 0 0;"><abbr class="colorGray959595 dis_line v_m m_r_10">百钢欢迎您！</abbr><abbr>{{ MemberInfo.name }}</abbr><i style="font-size: 10px;margin-left: 5px" class="icon iconfont f_w iconicon-"></i></div>-->
<!--            <div style="top: 30px;left: 0;width: 200px;padding: 10px;text-align: left;" class="p_a ">-->
<!--              <div>-->
<!--                <p style="line-height: 20px">当前身份：{{ returnType(MemberInfo.account && MemberInfo.account.type, MemberInfo.account && MemberInfo.account.companyAuth) }}</p>-->
<!--                <p style="line-height: 20px">{{ MemberInfo.mobile }}</p>-->
<!--              </div>-->
<!--              <div style="border-top: 1px solid #eee;padding-top: 10px">-->
<!--                <div style="width: 49%" class="dis_line">-->
<!--                  <div @click="toCenterUrl('companyBasicInfo')" class="title">账号信息</div>-->
<!--                </div>-->
<!--                <div style="width: 49%"  class="dis_line">-->
<!--                  <div @click="toCenterUrl('loginPwdmanage')" class="title">账号安全</div>-->
<!--                </div>-->
<!--                <div style="width: 49%"  class="">-->
<!--                  <div @click="$commonJs.loginOut('')" class="title">退出登录</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </span>
        <div style="margin-top: -2px;" class="hover p_r" @click="toIndexSearch('search')">
          <div class="hover2">百钢一下</div>
          <div style="top: 30px;left: 0;width: 200px;padding: 10px" class="p_a hoverShow t_c">
            <img src="../../assets/img/baigangSearch.png" style="width: 180px; height: 180px" alt="">
          </div>
        </div>
        <div style="margin-top: -2px;" class="hover p_r" @click="toIndex('mySteelMall')">
          <div class="hover2">百钢商城</div>
          <div style="top: 30px;left: 0;width: 200px;padding: 10px" class="p_a hoverShow t_c">
            <img src="../../assets/img/shangcheng.png" style="width: 180px; height: 180px" alt="">
          </div>
        </div>
        <!--      <div @click="toHelp">常见问题</div>-->
        <div style="margin-top: -2px;" class="hover p_r">
          <div class="hover2" @click="toLogin2"><abbr>卖家中心</abbr><i style="font-size: 10px;margin-left: 5px" class="icon iconfont f_w iconicon-"></i></div>
          <div style="top: 30px;left: 0;width: 100%;" class="p_a hoverShow t_c">
            <div @click="toGYUrl('myProductList')" class="title">上传资源</div>
            <div @click="toGYUrl('OrderList')" class="title">我的合同</div>
            <div @click="toGYUrl('accountManagement')" class="title">我的仓库</div>
          </div>
        </div>
        <div style="margin-top: -2px;" class="hover p_r">
          <div class="hover2" @click="toLogin"><abbr>买家中心</abbr><i style="font-size: 10px;margin-left: 5px" class="icon iconfont f_w iconicon-"></i></div>
          <div style="top: 30px;left: 0;width: 200px;padding: 10px 0" class="p_a hoverShow t_c">
            <div style="width: 49%" class="dis_line">
              <div @click="toCenterUrl('myProductList')" class="title">电商订单</div>
              <div @click="toCenterUrl('billManage')" class="title">我的提单</div>
              <div @click="toCenterUrl('myProcessing')" class="title">我的加工</div>
            </div>
            <div style="width: 49%;vertical-align: top"  class="dis_line">
              <div @click="toCenterUrl('purchaseManage')" class="title">我的求购</div>
              <div @click="toCenterUrl('invoiceManage')" class="title">开票记录</div>
              <div @click="toCenterUrl('moneyManager')" class="title">资金管理</div>
            </div>
          </div>
        </div>
        <div style="margin-top: -2px;" class="hover p_r">
          <div class="hover2"><abbr>客户服务</abbr><i style="font-size: 10px;margin-left: 5px" class="icon iconfont f_w iconicon-"></i></div>
          <div style="top: 30px;right: 0;width: 200px;padding: 10px;text-align: center;white-space: normal;" class="p_a t_c hoverShow">
            <div style="width: 49%" class="dis_line">
              <div @click="toSeachCangku" class="title">仓库查询</div>
            </div>
            <div style="width: 49%;vertical-align: top"  class="dis_line">
              <div @click="toSeachMaterial" class="title">材质查询</div>
            </div>
            <div style="width: 49%;vertical-align: top"  class="dis_line">
              <div @click="toHelp" class="title">常见问题</div>
            </div>
            <div style="width: 49%;vertical-align: top" v-for="(item, index) in helpList" :key="index" class="dis_line">
              <div class="title" @click="toHelpDetail(item)">{{item.name}}</div>
            </div>
            <div style="border-top: 1px solid #eee;padding-top: 10px">
              <p style="line-height: 20px">客服热线</p>
              <p style="line-height: 20px">0512-57667666（8:30-17:30）</p>
            </div>
          </div>
        </div>
        <!--      <div @click="toSeachMaterial">材质查询</div>-->
        <!--      <div @click="toSeachCangku">仓库查询</div>-->
        <!--      <div v-if="isRegister" @click="toUserCenter">欢迎您： {{ MemberInfo.nickName }}</div>-->
        <!--      <div>仓库查询</div>-->
        <!--      <div>牌号查询</div>-->
        <!--      <div>首页</div>-->
        <!--      <div class="notice">公告<i>5</i></div>-->
        <!--      <div>联系我们</div>-->
        <!--      <div>开户申请</div>-->
      </div>
    </nav>
  </div>
</template>

<script>
import pubilshSet from '../../assets/js/pubilshSet'

export default {
  name: 'allTop',
  props: [],
  data () {
    return {
      isRegister: window.localStorage.getItem('memberId'),
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      noticeList: [],
      noticeHtml: '',
      // 买家交易规则  常见操作指南  积分赚取  质量异议  退款退货
      helpList: [
        {
          name: '操作指南',
          url: 'helpDetail?id=8&subId=33'
        },
        {
          name: '积分赚取',
          url: 'helpDetail?id=10&subId=47'
        },
        {
          name: '交易规则',
          url: 'helpDetail?id=8&subId=32'
        },
        {
          name: '质量异议',
          url: 'helpDetail?id=10&subId=49'
        },
        {
          name: '退款退货',
          url: 'helpDetail?id=10&subId=50'
        }
      ]
    }
  },
  created () {
    // this.getNotice()
  },
  methods: {
    toHelp () {
      const newData = this.$router.resolve({
        name: 'help'
      })
      window.open(newData.href)
    },
    toHelpDetail (item) {
      // window.open(`${pubilshSet.userCenterHostUrl}help?item=${item}`)
      window.location.href = pubilshSet.searchHostUrl + `${item.url}`
    },
    toGYUrl (page) {
      window.open(pubilshSet.gongyingHostUrl + page)
    },
    toCenterUrl (page) {
      window.open(pubilshSet.userCenterHostUrl + page)
    },
    returnType (type, companyAuth) {
      if (parseInt(type) === 2) {
        return '供应商'
      } else {
        if (parseInt(companyAuth) === 2) {
          return '企业认证'
        } else {
          return '个人认证'
        }
      }
    },
    getNotice () {
      this.$axiox.get('/baigang/app/home/queryReleaseList').then(p => {
        this.noticeList = p.data.reverse()
        this.noticeHtml = ''
        for (let i = 0; i < this.noticeList.length; i++) {
          this.noticeHtml += this.noticeList[i].title + ' '
        }
      })
    },
    toLogin () {
      window.open(pubilshSet.userCenterHostUrl + 'login')
    },
    toUserCenter () {
      window.open(pubilshSet.userCenterHostUrl + 'index')
    },
    toIndexSearch (url) {
      window.location.href = pubilshSet.bgSearchHostUrl + url
    },
    toIndex (url) {
      window.location.href = pubilshSet.searchHostUrl
    },
    toSeachCangku () {
      this.$router.push({
        name: 'searchWareHouse'
      })
    },
    toSeachMaterial () {
      this.$router.push({
        name: 'searchMaterialQualityList'
      })
    },
    toLogin2 () {
      window.open(pubilshSet.gongyingHostUrl + 'myProductList')
    },
    toRegister () {
      window.open(pubilshSet.userCenterHostUrl + 'register')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myComponents/allTop.vue